import React, { useMemo, useState, useEffect } from "react";
import EquitySearchBlock from "./EquitySearchBlock";
import GenericDropdownTabs from "@frameworks/web/components/Search/Generic/GenericDropdownTabs";
import AllSearchDataBlock from "./AllSearchDataBlock";
import Loader from "@frameworks/web/components/generic/loader";
import searchDi from "./di/servicelocator";
import { SearchAssetTypeEnum, searchFilters } from "./constant";
import { getRecentSearchList } from "./RecentSearch";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import { updateChecked, } from "@frameworks/web/components/generic/FilterSidbar/GenericFilterSidebar";
import EdModal from "@frameworks/web/components/generic/edModal";
import { Col, Row } from "react-bootstrap";
import Checkbox from "@frameworks/web/components/generic/CheckBoxGeneric";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import { EExchangeType } from "@domains/features/Markets/Equity/entities/iTopGainersLosers";
import basicProfileDi from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import postLoginDi from "@frameworks/web/components/features/PostLoginDashboard/di/servicelocator";
import { useSelector } from "react-redux";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
import "../../stylesheets/components/Search/AllSearch.scss";
const ExchangeSelect = [
    { value: EExchangeType.NSE, display: "NSE" },
    { value: EExchangeType.BSE, display: "BSE" },
];
const SearchTabs = (props) => {
    var _a, _b;
    const device = DeviceContext();
    const { data: indexList, loader, errorData, } = useSelector((state) => state.postLogin.IndexDetails);
    const userId = useSelector((state) => state.accountDetailsReducer.userID);
    const guestUserID = useSelector((state) => state.LoginFlow.guestValidateMPIN.data.guestId);
    const [click, setClick] = React.useState(false);
    const [userID, setUserID] = useState();
    const [userType, setUserType] = useState();
    const [trending, setTrending] = useState();
    const [assetTrending, setAssetTrending] = useState();
    const [error, setError] = useState();
    const [recentSearch, setRecentSearch] = useState();
    const [filters, setFilters] = useState(searchFilters);
    const [defaultExchange, setDefaultExchange] = useState();
    const checkLoggedIn = useMemo(() => !!userID && userType === ILoginFlows.CLIENT, [userID, userType]);
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        if (!!guestUserID) {
            setUserType(ILoginFlows.GUEST);
            setUserID(guestUserID);
        }
    };
    useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    useEffect(() => {
        if (checkLoggedIn) {
            if (!!(indexList === null || indexList === void 0 ? void 0 : indexList.defExc)) {
                defaultExchangeApply(indexList === null || indexList === void 0 ? void 0 : indexList.defExc, false);
            }
            else {
                sessionStorage.setItem("defaultExchange", "true");
            }
        }
    }, [userID, userType]);
    // useEffect(() => {
    //   if (!!!props.searchData) {
    //     props.setLoader(true);
    //     const genTrending = searchDi.search.getTrending({});
    //     const trendingData = searchDi.search.allAssetTrending();
    //     Promise.all([trendingData])
    //       .then((data) => {
    //         setTrending(data[1].trending);
    //         setRecentSearch(data[1].recent);
    //         setAssetTrending(data[0]);
    //       })
    //       .catch((error: EdelError) => {
    //         setError(error.getErrorMessege());
    //       })
    //       .finally(() => setTimeout(() => props.setLoader(false), 100));
    //   }
    //   // getRecentSearchList().then((z) => setRecentSearch(z));
    //   if (checkLoggedIn) postLoginDi.postLogin.getIndexDetails();
    // }, []);
    useEffect(() => {
        getRecentSearchList().then((data) => {
            let request = "";
            data === null || data === void 0 ? void 0 : data.map((recent) => (request = request.concat(`${recent},`)));
            if (!!!props.searchData) {
                props.setLoader(true);
                const genTrending = searchDi.search.getTrending({
                    recentSymbols: request.slice(0, -1),
                });
                const trendingData = searchDi.search.allAssetTrending();
                Promise.all([trendingData, genTrending])
                    .then((data) => {
                    var _a;
                    setTrending(data[1].trending);
                    setRecentSearch((_a = data[1].recent) === null || _a === void 0 ? void 0 : _a.filter((x) => x !== null));
                    setAssetTrending(data[0]);
                })
                    .catch((error) => {
                    setError(error.getErrorMessege());
                })
                    .finally(() => setTimeout(() => props.setLoader(false), 100));
            }
            // getRecentSearchList().then((z) => setRecentSearch(z));
            if (checkLoggedIn)
                postLoginDi.postLogin.getIndexDetails();
        });
    }, []);
    const searchTabArray = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        const tabData = [
            {
                title: "All",
                eventKey: "All",
                value: "All",
                filters: false,
                tabContent: (React.createElement(AllSearchDataBlock, { data: props.searchData, trending: trending, assetTrending: assetTrending, recentSearch: recentSearch, closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol, setShowMFToc: props === null || props === void 0 ? void 0 : props.setShowMFToc })),
            },
            {
                title: "EQ",
                eventKey: "EQ",
                filters: false,
                value: SearchAssetTypeEnum.Equity,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_b = (_a = props.searchData) === null || _a === void 0 ? void 0 : _a.find((x) => x.assetType === SearchAssetTypeEnum.Equity)) === null || _b === void 0 ? void 0 : _b.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Equity], search: props.search, recentType: SearchAssetTypeEnum.Equity, type: SearchAssetTypeEnum.Equity, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Equity), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.Equity), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "FUT",
                eventKey: "FUT",
                filters: false,
                value: SearchAssetTypeEnum.Future,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_d = (_c = props.searchData) === null || _c === void 0 ? void 0 : _c.find((x) => x.assetType === SearchAssetTypeEnum.Future)) === null || _d === void 0 ? void 0 : _d.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Future], search: props.search, recentType: SearchAssetTypeEnum.Future, type: SearchAssetTypeEnum.Future, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Future), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "OPT",
                eventKey: "OPT",
                value: SearchAssetTypeEnum.Option,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_f = (_e = props.searchData) === null || _e === void 0 ? void 0 : _e.find((x) => x.assetType === SearchAssetTypeEnum.Option)) === null || _f === void 0 ? void 0 : _f.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Option], search: props.search, recentType: SearchAssetTypeEnum.Option, type: SearchAssetTypeEnum.Option, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Future), selectedOption: props.selectedOption, closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "MF",
                eventKey: "MF",
                value: SearchAssetTypeEnum.MF,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_h = (_g = props.searchData) === null || _g === void 0 ? void 0 : _g.find((x) => x.assetType === SearchAssetTypeEnum.MF)) === null || _h === void 0 ? void 0 : _h.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.MF], search: props.search, recentType: SearchAssetTypeEnum.MF.toUpperCase(), type: SearchAssetTypeEnum.MF, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.MF), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.MF), closePopup: () => props.serachPopup(false), setShowMFToc: props === null || props === void 0 ? void 0 : props.setShowMFToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "CUR",
                eventKey: "CUR",
                value: SearchAssetTypeEnum.Currency,
                tabContent: filters
                    .find((x) => x.filterName === SearchAssetTypeEnum.Currency)
                    .list.find((x) => x.key === "OPT").selected ? (props.openOption ? (React.createElement(EquitySearchBlock, { data: ((_k = (_j = props.searchData) === null || _j === void 0 ? void 0 : _j.find((x) => x.assetType === SearchAssetTypeEnum.Currency)) === null || _k === void 0 ? void 0 : _k.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Currency], search: props.search, recentType: SearchAssetTypeEnum.Currency.toUpperCase(), type: SearchAssetTypeEnum.Currency, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Currency), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.Currency), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })) : (React.createElement(React.Fragment, null))) : (React.createElement(EquitySearchBlock, { data: ((_m = (_l = props.searchData) === null || _l === void 0 ? void 0 : _l.find((x) => x.assetType === SearchAssetTypeEnum.Currency)) === null || _m === void 0 ? void 0 : _m.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Currency], search: props.search, recentType: SearchAssetTypeEnum.Currency, type: SearchAssetTypeEnum.Currency, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Currency), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.Currency), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            // {
            //   title: "COM",
            //   eventKey: "COM",
            //   value: SearchAssetTypeEnum.Commodity,
            //   filters: false,
            //   tabContent: (
            //     <EquitySearchBlock
            //       data={
            //         props.searchData?.find(
            //           (x) => x.assetType === SearchAssetTypeEnum.Commodity
            //         )?.data || []
            //       }
            //       trending={
            //         !!assetTrending && assetTrending[SearchAssetTypeEnum.Commodity]
            //       }
            //       search={props.search}
            //       recentType={SearchAssetTypeEnum.Commodity.toUpperCase()}
            //       type={SearchAssetTypeEnum.Commodity}
            //       recentSearch={recentSearch}
            //     />
            //   ),
            // },
            {
                title: "PRIMARY MRK",
                eventKey: "PRIMARY MRK",
                value: SearchAssetTypeEnum.PrimaryMarket,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_p = (_o = props.searchData) === null || _o === void 0 ? void 0 : _o.find((x) => x.assetType === SearchAssetTypeEnum.PrimaryMarket)) === null || _p === void 0 ? void 0 : _p.data) || [], trending: !!assetTrending &&
                        assetTrending[SearchAssetTypeEnum.PrimaryMarket], search: props.search, recentType: SearchAssetTypeEnum.PrimaryMarket, type: SearchAssetTypeEnum.PrimaryMarket, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.PrimaryMarket), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.PrimaryMarket), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "ETF",
                eventKey: "ETF",
                value: SearchAssetTypeEnum.ETFs,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_r = (_q = props.searchData) === null || _q === void 0 ? void 0 : _q.find((x) => x.assetType === SearchAssetTypeEnum.ETFs)) === null || _r === void 0 ? void 0 : _r.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.ETFs], search: props.search, recentType: SearchAssetTypeEnum.ETFs, type: SearchAssetTypeEnum.ETFs, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.ETFs), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "NCD",
                eventKey: "NCD",
                value: SearchAssetTypeEnum.NcdSecondary,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_t = (_s = props.searchData) === null || _s === void 0 ? void 0 : _s.find((x) => x.assetType === SearchAssetTypeEnum.NcdSecondary)) === null || _t === void 0 ? void 0 : _t.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.NcdSecondary], search: props.search, recentType: SearchAssetTypeEnum.NcdSecondary, type: SearchAssetTypeEnum.NcdSecondary, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.NcdSecondary), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "INDICES",
                eventKey: "INDICES",
                value: SearchAssetTypeEnum.Indices,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_v = (_u = props.searchData) === null || _u === void 0 ? void 0 : _u.find((x) => x.assetType === SearchAssetTypeEnum.Indices)) === null || _v === void 0 ? void 0 : _v.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.Indices], search: props.search, recentType: SearchAssetTypeEnum.Indices, type: SearchAssetTypeEnum.Indices, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Indices), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            // {
            //   title: "SGB",
            //   eventKey: "SGB",
            //   value: SearchAssetTypeEnum.SGB,
            //   filters: false,
            //   tabContent: (
            //     <EquitySearchBlock
            //       data={
            //         props.searchData?.find(
            //           (x) => x.assetType === SearchAssetTypeEnum.SGB
            //         )?.data || []
            //       }
            //       trending={!!assetTrending && assetTrending[SearchAssetTypeEnum.SGB]}
            //       search={props.search}
            //       recentType={SearchAssetTypeEnum.SGB.toUpperCase()}
            //       type={SearchAssetTypeEnum.SGB}
            //       recentSearch={recentSearch?.filter(
            //         (x) => x?.assetType === SearchAssetTypeEnum.SGB
            //       )}
            //       closePopup={() => props.serachPopup(false)}
            //     />
            //   ),
            // },
            // {
            //   title: "CORP FD",
            //   eventKey: "CORP FD",
            //   value: SearchAssetTypeEnum.CORPFD,
            //   filters: false,
            //   tabContent: (
            //     <EquitySearchBlock
            //       data={
            //         props.searchData?.find(
            //           (x) => x.assetType === SearchAssetTypeEnum.CORPFD
            //         )?.data || []
            //       }
            //       trending={
            //         !!assetTrending && assetTrending[SearchAssetTypeEnum.CORPFD]
            //       }
            //       search={props.search}
            //       recentType={SearchAssetTypeEnum.CORPFD.toUpperCase()}
            //       type={SearchAssetTypeEnum.CORPFD}
            //       recentSearch={recentSearch?.filter(
            //         (x) => x?.assetType === SearchAssetTypeEnum.CORPFD
            //       )}
            //       closePopup={() => props.serachPopup(false)}
            //     />
            //   ),
            // },
            {
                title: "COMFUT",
                eventKey: "COMFUT",
                value: SearchAssetTypeEnum.ComFut,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_x = (_w = props.searchData) === null || _w === void 0 ? void 0 : _w.find((x) => x.assetType === SearchAssetTypeEnum.ComFut)) === null || _x === void 0 ? void 0 : _x.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.ComFut], search: props.search, recentType: SearchAssetTypeEnum.ComFut.toUpperCase(), type: SearchAssetTypeEnum.ComFut, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Commodity), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.ComFut), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            {
                title: "COMOPT",
                eventKey: "COMOPT",
                value: SearchAssetTypeEnum.ComOpt,
                filters: false,
                tabContent: (React.createElement(EquitySearchBlock, { data: ((_z = (_y = props.searchData) === null || _y === void 0 ? void 0 : _y.find((x) => x.assetType === SearchAssetTypeEnum.ComOpt)) === null || _z === void 0 ? void 0 : _z.data) || [], trending: !!assetTrending && assetTrending[SearchAssetTypeEnum.ComOpt], search: props.search, recentType: SearchAssetTypeEnum.ComOpt.toUpperCase(), type: SearchAssetTypeEnum.ComOpt, recentSearch: recentSearch === null || recentSearch === void 0 ? void 0 : recentSearch.filter((x) => (x === null || x === void 0 ? void 0 : x.assetType) === SearchAssetTypeEnum.Commodity), filters: filters.find((x) => x.filterName === SearchAssetTypeEnum.ComOpt), closePopup: () => props.serachPopup(false), setShowToc: props === null || props === void 0 ? void 0 : props.setShowToc, setSymbol: props === null || props === void 0 ? void 0 : props.setSymbol })),
            },
            // {
            //   title: "NFO",
            //   eventKey: "NFO",
            //   value: SearchAssetTypeEnum.NFO,
            //   tabContent: <NfoSearchBlock />,
            // },
            // {
            //   title: "OFS",
            //   eventKey: "OFS",
            //   value: SearchAssetTypeEnum.OFS,
            //   tabContent: <OfsSearchBlock />,
            // },
        ];
        if (props.searchData && ((_0 = props.searchData) === null || _0 === void 0 ? void 0 : _0.length) > 0) {
            return props.searchData
                .map((z) => {
                const tab = tabData.find((x) => x.value === z.assetType);
                if (SearchAssetTypeEnum.Equity === z.assetType) {
                    return Object.assign(Object.assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.Currency === z.assetType) {
                    return Object.assign(Object.assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.ComFut === z.assetType) {
                    return Object.assign(Object.assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.ComOpt === z.assetType) {
                    return Object.assign(Object.assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.PrimaryMarket === z.assetType) {
                    return Object.assign(Object.assign({}, tab), { filters: true });
                }
                if (SearchAssetTypeEnum.MF === z.assetType) {
                    return Object.assign(Object.assign({}, tab), { filters: true });
                }
                return tabData.find((x) => x.value === z.assetType);
            })
                .filter((x) => x);
        }
        return tabData;
    }, [
        props.searchData,
        trending,
        assetTrending,
        recentSearch,
        JSON.stringify(filters),
        props.openOption,
    ]);
    useEffect(() => {
        if (searchTabArray.length > 0 && !props.openOption)
            props.setActiveTab(searchTabArray[0].eventKey);
    }, [searchTabArray, props.openOption]);
    const defaultExchangeApply = (dExchange, update) => {
        const exchangeFilter = filters.find((x) => x.filterName === SearchAssetTypeEnum.Equity);
        const id = exchangeFilter.list.findIndex((x) => x.key === dExchange);
        let e = {
            target: {
                checked: true,
                type: "checkbox",
            },
        };
        updateChecked(e, exchangeFilter.filterName, id, setFilters);
        if (update && checkLoggedIn) {
            const payload = {
                exc: defaultExchange,
            };
            basicProfileDi.basicProfile.defaultExchangeData(payload);
        }
        setClick(false);
    };
    return (React.createElement(React.Fragment, null,
        props.loader ? (React.createElement(React.Fragment, null,
            React.createElement(Loader, null))) : (React.createElement("div", { className: "search-modal-tabslist" },
            React.createElement(GenericDropdownTabs, { defaultActiveKey: props.activeTab, tabsArray: searchTabArray, filterList: filters, setFilter: setFilters, setOptions: props.setOpt, forceUpdateTab: props.setActiveTab, searchString: ((_a = props === null || props === void 0 ? void 0 : props.search) === null || _a === void 0 ? void 0 : _a.length) > 0, onCallBackFunction: () => {
                    if (!!userID &&
                        userType === ILoginFlows.CLIENT &&
                        sessionStorage.getItem("defaultExchange") === "true")
                        setClick(true);
                } }),
            props.search && ((_b = props.searchData) === null || _b === void 0 ? void 0 : _b.length) === 0 && (React.createElement(Errormsg, { icon: "", msg: "No results found", showIcon: false })))),
        device && device.isDesktop ? (React.createElement(React.Fragment, null,
            " ",
            React.createElement(EdModal, { show: click, setShow: setClick, modalTitle: "commonmodal ", title: "Select Default Exchange", size: "commonmodal gray-modal defaultExchange-modal  modal-md modal-dialog-centered", showFooter: false, DisableOutsideClickClose: true, onCloseGoBack: true, onCloseGoBackFunction: () => {
                    setClick(false);
                    setDefaultExchange(undefined);
                    if (checkLoggedIn) {
                        sessionStorage.setItem("defaultExchange", "false");
                    }
                } },
                React.createElement(Row, { className: "mx-0" },
                    React.createElement(Col, { lg: 12 },
                        React.createElement("span", { className: "d-flex DMSans_16_500 txt_blackOne1" }, "Select exchange you\u2019d like to keep default for search results"),
                        React.createElement("span", { className: "d-flex DMSanN_14_400 txt_secondary-gray" }, "This will be applicable across the site. You can always change it in Settings.")),
                    React.createElement(Col, { lg: 4, className: "mgt-20" },
                        React.createElement("div", { className: "grid-2 gap-15" }, ExchangeSelect.map((x) => {
                            return (React.createElement("div", { className: "common-checkbox" },
                                React.createElement("div", { className: "customFormSection_field checkboxWrap border-box-checkbox" },
                                    React.createElement("div", { className: "checkbox" },
                                        React.createElement("div", { className: "form-check" },
                                            React.createElement(Checkbox, { list: x, name: "placeorder", className: "checkbox common-checkbox-new", onChange: (e) => {
                                                    if (e.target.checked)
                                                        setDefaultExchange(e.target.value);
                                                    else
                                                        setDefaultExchange(undefined);
                                                }, selected: defaultExchange }))))));
                        }))),
                    React.createElement(Col, { lg: 12, className: "mgt-20" },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 6, xs: 6, className: "ps-3 d-center-end" },
                                React.createElement(EdButton, { disabled: !!defaultExchange ? false : true, btnTyp: "midnight-blue", value: "Apply", onClick: () => defaultExchangeApply(defaultExchange, true) })),
                            React.createElement(Col, { lg: 6, xs: 6, className: "pe-3" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", onClick: () => {
                                        setClick(false);
                                        setDefaultExchange(undefined);
                                    }, value: "Cancel" })))))))) : (React.createElement("div", { className: "mb-genericSidebar" },
            React.createElement(GenericDrawer, { parentClass: "z-index-high", show: click, setShow: setClick, bodyComp: React.createElement(Row, { className: "mx-0" },
                    React.createElement(Col, { lg: 12 },
                        React.createElement("span", { className: "d-flex DMSans_16_500 txt_blackOne1 mgt-20 line-20" }, "Select exchange you\u2019d like to keep default for search results"),
                        React.createElement("span", { className: "d-flex DMSanN_14_400 txt_secondary-gray mgt-5 line-20" }, "This will be applicable across the site. You can always change it in Settings.")),
                    React.createElement(Col, { lg: 4, className: "mgt-20" },
                        React.createElement("div", { className: "grid-4 gap-15" }, ExchangeSelect.map((x) => {
                            return (React.createElement("div", { className: "common-checkbox" },
                                React.createElement("div", { className: "customFormSection_field checkboxWrap border-box-checkbox" },
                                    React.createElement("div", { className: "checkbox" },
                                        React.createElement("div", { className: "form-check" },
                                            React.createElement(Checkbox, { list: x, name: "placeorder", className: "checkbox common-checkbox-new", onChange: (e) => {
                                                    if (e.target.checked)
                                                        setDefaultExchange(e.target.value);
                                                    else
                                                        setDefaultExchange(undefined);
                                                }, selected: defaultExchange }))))));
                        }))),
                    React.createElement(Col, { lg: 12, className: "mgt-20" },
                        React.createElement(Row, null,
                            React.createElement(Col, { lg: 6, xs: 6, className: "ps-3 d-center-end" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", className: "w-100", onClick: () => {
                                        setClick(false);
                                        setDefaultExchange(undefined);
                                    } })),
                            React.createElement(Col, { lg: 6, xs: 6, className: "pe-3" },
                                React.createElement(EdButton, { disabled: !!defaultExchange ? false : true, btnTyp: "midnight-blue", value: "Apply", className: "w-100", onClick: () => defaultExchangeApply(defaultExchange, true) }))))), headerComp: React.createElement("div", { className: "DMSan_16_700 txt_blackOne1 p-3" }, "Select Default Exchange") })))));
};
export default SearchTabs;
